/**
 * scroll to an element in document
 * @param selector css selector
 * @param offset offset to add + or subtract -
 */
export function scrollToElement (selector, offset) {
  const el = document.querySelector(selector)
  const topCoordinate = el.offsetTop - offset
  window.scrollTo({
    top: topCoordinate,
    behavior: 'smooth'
  })
}
